<template>
  <div class="container">
    <div v-if="!file || formattedTable.length === 0">
      <label class="cmp-file-upload"
        >Caricare il file FE1.txt cliccando il seguente pulsante
        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" /> Allega File Txt</label
      >
      <span v-if="errors.uploadFile" class="alert">Estensione del file non supportata!</span>
      <span v-if="errors.parsing" class="alert">Errore nella decodifica del documento!</span>
    </div>
    <spinner :visible="isLoading"></spinner>
    <div v-if="file && formattedTable.length > 0 && !isLoading" class="overflow--h">
      <button type="button" class="advbtn--export--action js-tooltip" alt="Esporta" @click="generateFile()">Esporta</button>
      <button type="button" class="advbtn--export--action js-tooltip" alt="Annulla" @click="reset()">Annulla</button>
      <div class="table">
        <div class="table__heading">
          <div
            v-for="(headerLabel, indexH) in headerLabels"
            :key="indexH"
            class="table__head"
            :style="'min-width: ' + getHeaderColWidht(indexH)"
          >
            {{ headerLabel }}
          </div>
        </div>
        <div class="table__body" v-if="headerColWidth.length > 0">
          <transition-group name="fade" tag="div">
            <div v-for="(formattedRow, indexR) in formattedTable" :key="formattedRow.id" class="table__row fade__item">
              <div class="table__cell text-align--center" :style="'min-width: ' + getHeaderColWidht(0)">{{ indexR + 1 }}</div>
              <div class="table__cell table__cell--flex" :style="'min-width: ' + getHeaderColWidht(1)">
                <button
                  type="button"
                  @click="clone(indexR)"
                  alt="Clona"
                  class="js-tooltip btn btn-link p-2"
                  title="Duplica la riga corrente"
                >
                  <i class="fa-light fa-clone"></i>
                </button>
                <button
                  type="button"
                  @click="remove(indexR)"
                  alt="Rimuovi"
                  class="js-tooltip btn btn-link p-2"
                  title="Elimina la riga corrente"
                >
                  <i class="fa-light fa-trash"></i>
                </button>
              </div>
              <div
                v-for="(cell, indexC) in formattedRow.data"
                :key="indexC"
                class="table__cell"
                :style="'width: ' + getHeaderColWidht(indexC + 2)"
              >
                <input
                  v-if="cell.type == 'boolean'"
                  class="width-inherit"
                  :type="'checkbox'"
                  :value="cell.value"
                  :checked="cell.value == cell.true_val"
                  :name="cell.name"
                  :readonly="cell.readonly"
                  :maxlength="cell.maxlength"
                  :style="'min-width: ' + getHeaderColWidht(indexC + 2)"
                  @change="
                    changeFormattedRowValue(($event.currentTarget.checked && cell.true_val) || cell.false_val, indexR, indexC, cell.name)
                  "
                />
                <input
                  v-else-if="cell.type != 'date'"
                  class="width-inherit"
                  :type="cell.type"
                  :value="cell.value"
                  :name="cell.name"
                  :readonly="cell.readonly"
                  :maxlength="cell.maxlength"
                  @change="changeFormattedRowValue($event.target.value, indexR, indexC, cell.name)"
                />
                <datepicker
                  v-else-if="cell.type == 'date'"
                  v-model="cell.value"
                  class="width-inherit"
                  :format="'yymmdd'"
                  :name="cell.name"
                  :readonly="cell.readonly"
                  @change="changeFormattedRowValue($event.target.value, indexR, indexC, cell.name)"
                >
                </datepicker>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from '../datepicker';
import spinner from '../spinner';

export default {
  name: 'fe1FluxTxtComponent',
  components: {
    datepicker,
    spinner,
  },
  data: function () {
    return {
      maxId: 0,
      file: null,
      isLoading: false,
      formattedTable: [],
      errors: {
        uploadFile: false,
        parsing: false,
      },
      headerLabels: [
        '#',
        'Azioni',
        'ATS',
        'UDO',
        'Codice struttura completo',
        'Periodo di rendicontazione',
        'Codice individuale ospite',
        'Data di nascita',
        'Codice ISTAT comune imputazione tariffa socio-sanitaria',
        'Codice ATS di eventuale imputazione tariffa sociosanitaria',
        'Tipologia presa in carico',
        'Classificazione posto',
        'Specifica tipologia posto',
        'Specifica Utente',
        'Utente solvente',
        'Codice DRG',
        'Data inizio condizione',
        'Data fine condizione',
        'Utente presente alla data di fine condizione',
        'Giornate complessive di assenza nel periodo di rendicontazione',
        'Totale giornate di assenza nel periodo di rendicontazione con oneri a carico FSR',
        'Giornate / trattamenti complessivi',
        'Giornate presenza/Trattamenti (entro soglia)',
        'Giornate / trattamenti oltre soglia 1',
        'Giornate / trattamenti oltre soglia 2',
        'Tariffa die / Trattamento entro soglia / Tariffa die base',
        'Tariffa die / Trattamento Base oltre soglia 1',
        'Tariffa die / Trattamento Base oltre soglia 2',
        'Tariffa die / Trattamento aggiuntiva',
        'Quota tariffa die a budget',
        'Importo complessivo ticket quota base',
        'Importo complessivo ticket quota aggiuntiva',
      ],
      colsConfig: [
        { name: 'ats', type: 'text', length: 3, index: 1, readonly: true },
        { name: 'udo', type: 'text', length: 3, index: 2, readonly: true },
        { name: 'codice_struttura_completo', type: 'text', length: 9, index: 3, readonly: true },
        { name: 'rendicontazione', type: 'text', length: 7, index: 4 },
        { name: 'codice_individuale_assistito', type: 'text', length: 32, index: 5 },
        { name: 'data_di_nascita', type: 'date', length: 8, index: 6 },
        { name: 'codice_istat', type: 'text', length: 6, index: 7 },
        { name: 'codice_ats', type: 'text', length: 3, index: 8 },
        { name: 'tipologia_presa_in_carico', type: 'number', length: 1, index: 9 },
        { name: 'classificazione_posto', type: 'number', length: 1, index: 10 },
        { name: 'specifica_tipologia_posto', type: 'text', length: 1, index: 11 },
        { name: 'specifica_utente', type: 'text', length: 15, index: 12 },
        { name: 'utente_solvente', type: 'boolean', length: 1, index: 13, true_val: '1', false_val: '2' },
        { name: 'codice_drg', type: 'text', length: 3, index: 14 },
        { name: 'data_inizio_condizione', type: 'date', length: 8, index: 15 },
        { name: 'data_fine_condizione', type: 'date', length: 8, index: 16 },
        { name: 'utente_presente', type: 'boolean', length: 1, index: 17, true_val: '1', false_val: '2' },
        { name: 'giornate_complessive_assenza', type: 'text', length: 3, index: 18 },
        { name: 'giornate_assenza_ssn', type: 'text', length: 3, index: 19 },
        { name: 'giornate_trattamenti_complessive', type: 'text', length: 3, index: 20 },
        { name: 'giornate_trattamenti_presenza_entro_soglia', type: 'text', length: 3, index: 21 },
        { name: 'giornate_trattamenti_oltre_soglia_1', type: 'text', length: 3, index: 22 },
        { name: 'giornate_trattamenti_oltre_soglia_2', type: 'text', length: 3, index: 23 },
        { name: 'tariffa_die_base', type: 'text', length: 8, index: 24 },
        { name: 'tariffa_entro_soglia_1', type: 'text', length: 8, index: 25 },
        { name: 'tariffa_entro_soglia_2', type: 'text', length: 8, index: 26 },
        { name: 'tariffa_die_trattamento_aggiuntivo', type: 'text', length: 8, index: 27 },
        { name: 'quota_tariffa_die_a_budget', type: 'text', length: 8, index: 28 },
        { name: 'importo_complessivo_ticket_quota_base', type: 'text', length: 8, index: 29 },
        { name: 'importo_complessivo_ticket_quota_aggiuntiva', type: 'text', length: 8, index: 30 },
      ],
      headerColWidth: [],
    };
  },
  methods: {
    handleFileUpload() {
      const tmpRefFile = this.$refs.file.files[0];
      if (tmpRefFile && tmpRefFile.name.endsWith('.txt')) {
        this.errors.uploadFile = false;
        this.errors.parsing = false;
        this.file = tmpRefFile;
        this.constructFormattedTable(tmpRefFile)
          .then((result) => {
            this.formatTable(result);
            setTimeout(() => {
              window.BTTooltip.init();
            }, 400);
          })
          .catch((error) => {
            console.error('Some problem during upload of file', error);
            this.errors.parsing = true;
            this.isLoading = false;
          });
      } else {
        console.error('Some problem during upload of file');
        this.errors.uploadFile = true;
      }
    },
    clone(index) {
      const formattedRow = [];
      this.maxId += 1;
      this.colsConfig.forEach((colConfig, indexC) => {
        const formattedCell = { ...colConfig };
        formattedCell.readonly = !!colConfig.readonly;
        formattedCell.maxlength = colConfig.length;
        formattedCell.value = this.formattedTable[index].data[indexC].value;
        formattedRow.push(formattedCell);
      });
      this.formattedTable.splice(index + 1, 0, { id: this.maxId, data: formattedRow });
    },
    remove(index) {
      this.formattedTable.splice(index, 1);
    },
    generateFile(e) {
      let str = '';
      this.formattedTable.forEach((row) => {
        row.data.forEach((col) => {
          const minLength = this.colsConfig.find((config) => config.name === col.name).length;
          // here rpad with space
          str += (col.value || '').padEnd(minLength);
        });
        str += '\r\n';
      });
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(str));
      const now = new Date();
      let filename = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
      filename += `_${String(now.getUTCHours()).padStart(2, '0')}${String(now.getUTCMinutes()).padStart(2, '0')}${String(now.getUTCSeconds()).padStart(2, '0')}_FE4_updated.txt`;
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    constructFormattedTable(file) {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = function (event) {
          const contents = event.target.result;
          const lines = contents.split('\n');
          resolve(lines);
        };
        reader.onerror = function (event) {
          reject(event);
        };
        reader.readAsText(file);
      });
    },
    formatTable(lines) {
      let formattedRow = null;
      lines.forEach((line, index) => {
        if (line && line !== '') {
          formattedRow = [];
          let start = 0;
          this.colsConfig.forEach((colConfig) => {
            const formattedCell = { ...colConfig };
            formattedCell.readonly = !!colConfig.readonly;
            formattedCell.maxlength = colConfig.length;
            formattedCell.value = line.substr(start, colConfig.length);
            start += colConfig.length;
            formattedRow.push(formattedCell);
          });
          this.formattedTable.push({ id: index, data: formattedRow });
        }
      });
      this.maxId = lines.length;
      this.isLoading = false;
      this.$nextTick(() => {
        const table = document.getElementsByClassName('table')[0];
        const heading = table && table.getElementsByClassName('table__heading')[0];
        if (heading) {
          const cellHeadingCollection = heading.getElementsByClassName('table__head');
          for (var i = 0; i < cellHeadingCollection.length; i++) {
            if (i > 1) {
              this.headerColWidth.push(Math.max(cellHeadingCollection[i].clientWidth, this.colsConfig[i - 2].length * 16));
            } else {
              i === 0 ? this.headerColWidth.push(48) : this.headerColWidth.push(70);
            }
          }
        }
      });
    },
    changeFormattedRowValue(value, r, c, name) {
      this.formattedTable[r].data[c].value = value;
    },
    reset() {
      this.formattedTable.splice(0, this.formattedTable.length);
      this.file = null;
      this.headerColWidth.splice(0, this.headerColWidth.length);
      this.maxId = 0;
    },
    getHeaderColWidht(index) {
      return this.headerColWidth[index] + 'px;';
    },
  },
};
</script>

<style lang="scss" scoped>
.overflow--h {
  scrollbar-color: orange grey;
  overflow-x: visible;
}
.container {
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1000ms;
}
.fade__item {
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
}
.table {
  display: block;
  height: 600px;
  overflow-y: scroll;
}
.table__row {
  display: table-row;
}
.table__heading {
  display: block;
  position: sticky;
  top: 0px;
  z-index: 2;
}
.table__body {
  display: table-row-group;
}
.table__footer {
  display: table-footer-group;
}
.table__cell,
.table__head {
  display: table-cell;
  border: 1px solid #ef7b0f;
  height: 17px;
  text-align: center;
}
.table__cell--flex {
  display: inline-flex;
  height: auto;
}
.table__head {
  vertical-align: middle;
  background-color: #ef990f;
  font-weight: bold;
  color: white;
}
.px-10 {
  padding: 0px 10px;
}
.p-2 {
  padding: 2px;
}
input[type='text'],
input[type='number'] {
  padding: 0;
}
.text-align--center {
  text-align: center;
}
.table__cell > input {
  border-width: 0px 0px 2px 0px;
  text-align: center;
}
.table__row > .table__cell:nth-child(2) {
  padding: 4px 0px 8px;
}
.width-inherit {
  width: inherit;
}
</style>
